import { NgModule } from "@angular/core";

import { extModules } from "../../../build-specifics";

import { AppComponent } from "./app.component";
import { AppModule } from "./app.module";

@NgModule({
	imports: [AppModule, extModules],
	bootstrap: [AppComponent],
})
export class AppClientModule {}
